import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "selectors"
    }}>{`Selectors`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Adjacent%20Sibling%20combinator.md"
        }}>{`Adjacent Sibling combinator`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Attribute%20selector.md"
        }}>{`Attribute selector`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Child%20combinator.md"
        }}>{`Child combinator`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Class%20selector.md"
        }}>{`Class selector`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Descendant%20combinator.md"
        }}>{`Descendant combinator`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "General%20Sibling%20combinator.md"
        }}>{`General Sibling combinator`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Identifier%20selector.md"
        }}>{`Identifier selector`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Type%20selector.md"
        }}>{`Type selector`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Universal%20selector.md"
        }}>{`Universal selector`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      